// extracted by mini-css-extract-plugin
export default {"paginationButtons":"pagination_paginationButtons__+vV9H"};